import React, { useEffect, useState } from "react";
import Link from "next/link";
import styled from "@emotion/styled";
import Fade from "react-reveal/Fade";
import useSettings from "stores/settings";
import Grid from "@mui/material/Grid";
import RenewalPopover from "components/RenewalPopover";
// import HomePopover from "components/HomePopover";

const Home = () => {
  const settings = useSettings();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    settings.currentMenu = "home";
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    handleResize(); // 초기값 설정
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <HomeContainer>
      <RenewalPopover />
      {/* <HomePopover /> */}

      <HomeTitleSection isMobile={isMobile}>
        <Fade bottom>
          <div className="title">
            인공지능앱 제작소 <br />
            AI Love School에 오신것을 <br />
            환영합니다!
          </div>
          <div className="sub_title">내 채널에서 생성형 AI 앱을 만들고 바로 활용해보세요!</div>
        </Fade>
        <Fade bottom>
          <ButtonLink href="https://ailove.school/about/" isMobile={isMobile} target="_blank" rel="noopener noreferrer">
            AI LOVE SCHOOL 바로가기
          </ButtonLink>
        </Fade>
      </HomeTitleSection>

      <ContentSection isMobile={isMobile}>
        <Grid
          container
          rowSpacing={3}
          columnSpacing={{ xs: 2, lg: 2, xl: 3 }}
          direction="row"
          sx={{ justifyContent: "center", alignItems: "stretch" }}
        >
          <GridItem item xs={12} md={6} lg={3}>
            <Fade bottom>
              <GridBox>
                <h3>01</h3>
                <div>쉬운 앱 제작</div>
                <p>제공되는 툴들을 체인처럼 연결하여 쉽게 앱을 만들 수 있습니다</p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={3}>
            <Fade bottom>
              <GridBox>
                <h3>02</h3>
                <div>정확한 출력물</div>
                <p>설계 의도에 맞는 정확한 출력물로 업무에 바로 사용이 가능합니다</p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={3}>
            <Fade bottom>
              <GridBox>
                <h3>03</h3>
                <div>데이터베이스 연동</div>
                <p>복사 붙여넣기는 이제 그만. 이제 최종 데이터베이스까지 쉽게 연동이 가능합니다</p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={3}>
            <Fade bottom>
              <GridBox>
                <h3>04</h3>
                <div>나의 앱을 공유</div>
                <p>나의 채널을 통해 인공지능 앱을 다른 사용자들과 공유가 가능합니다</p>
              </GridBox>
            </Fade>
          </GridItem>
        </Grid>
      </ContentSection>

      <ContentSection isMobile={isMobile}>
        <Fade bottom>
          <ContentTitle>AI LOVE SCHOOL 이런 기능이 있습니다!</ContentTitle>
        </Fade>
        <Grid container rowSpacing={3} columnSpacing={{ xs: 2, lg: 2, xl: 3 }}>
          <GridItem item xs={12} md={6} lg={4}>
            <Fade bottom>
              <GridBox>
                <div>앱 만들기 기능</div>
                <p>직관적인 앱 생성 플로우를 만들고 쉽게 단계별 수정과 결과 확인이 가능합니다.</p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={4}>
            <Fade bottom>
              <GridBox>
                <div>다양한 기능을 앱에 통합</div>
                <p>텍스트,이미지,동영상,음성,코딩 등을 하나의 앱에 통합이 가능합니다</p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={4}>
            <Fade bottom>
              <GridBox>
                <div>반복적인 작업 자동화</div>
                <p>각종 작업을 자동화하여 업무 효율을 높일 수 있습니다. 제공되는 샘플들을 보면서 따라해 보세요</p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={4}>
            <Fade bottom>
              <GridBox>
                <div>각종 분석 기능 기본 제공</div>
                <p>데이터 파일을 업로드 하는 것만으로도 다양한 분석 결과를 얻고 변환할 수 있습니다</p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={4}>
            <Fade bottom>
              <GridBox>
                <div>사용량 분석</div>
                <p>
                  사용량에 따라 요금이 부과되며, 사용량을 바로 확인이 가능합니다. 내가 만든 인기있는 앱들의 사용 현황으로 새로운 수익 창출
                </p>
              </GridBox>
            </Fade>
          </GridItem>
          <GridItem item xs={12} md={6} lg={4}>
            <Fade bottom>
              <GridBox>
                <div>계속 추가되는 새로운 기능</div>
                <p>다양한 앱들을 보다 빨리 만들고 사용가능하도록 많은 툴들이 지속적으로 제공됩니다</p>
              </GridBox>
            </Fade>
          </GridItem>
        </Grid>
      </ContentSection>

      <BgContentSection isMobile={isMobile}>
        <Fade bottom>
          <Grid
            container
            rowSpacing={3}
            columnSpacing={{ xs: 2, md: 2 }}
            sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
          >
            <GridItem item xs={12} md={6} sx={{ textAlign: isMobile ? "center" : "left" }}>
              <Fade bottom>
                <TextBox isMobile={isMobile}>
                  <h5>AI 앱 제작, 이제 아이디어만 있으면 충분합니다.</h5>
                  <p>
                    자동화, 데이터 분석, 다양한 생성형 기능까지
                    <br /> AI Love School에서는 복잡한 설정 없이 앱 제작부터 배포, 공유까지 한 번에 해결할 수 있어요.
                    <br /> 지금 바로 나만의 AI 앱을 만들고, 진짜 업무에 활용해보세요!
                  </p>
                </TextBox>
              </Fade>
            </GridItem>
            <GridItem item xs={12} md={6} sx={{ display: "flex", justifyContent: isMobile ? "center" : "flex-end", alignItems: "center" }}>
              <Fade bottom>
                <WhiteButtonLink isMobile={isMobile} href="https://ailove.school/explore/" target="_blank" rel="noopener noreferrer">
                  AI LOVE SCHOOL 시작하기
                </WhiteButtonLink>
              </Fade>
            </GridItem>
          </Grid>
        </Fade>
      </BgContentSection>
    </HomeContainer>
  );
};

export default Home;

const HomeContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #f1f7f2;
`;

const HomeTitleSection = styled.div`
  width: 100%;
  min-height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: ${({ isMobile }) => (isMobile ? "5rem" : "7rem")};
  padding-bottom: ${({ isMobile }) => (isMobile ? "5rem" : "7rem")};
  padding-left: ${({ isMobile }) => (isMobile ? "1.5rem" : "2rem")};
  padding-right: ${({ isMobile }) => (isMobile ? "1.5rem" : "2rem")};

  > div {
    width: 100%;
    word-break: keep-all;
    color: rgb(28, 105, 99);

    &.title {
      font-family: "GmarketSansMedium";
      font-size: ${({ isMobile }) => (isMobile ? "2rem" : "4.5rem")};
      line-height: 1.3;
      font-weight: bold;
      margin: 2rem 0;
    }

    &.sub_title {
      font-size: ${({ isMobile }) => (isMobile ? "1.2rem" : "2.5rem")};
      padding: 0.5rem 0;
      padding-top: ${({ isMobile }) => (isMobile ? "1rem" : "5rem")};
    }
  }
`;

const ButtonLink = styled(Link)`
  margin: 0 auto;
  width: auto;
  max-width: 300px;
  font-size: ${({ isMobile }) => (isMobile ? "1rem" : "1.2rem")};
  font-weight: 600;
  background-color: #00897b;
  color: #fff;
  padding: 1rem 2rem;
  border-radius: 1rem;
  text-decoration: none;
  margin-top: ${({ isMobile }) => (isMobile ? "2rem" : "10rem")};
  transition: all 0.2s ease;

  :hover {
    background-color: #004d40;
    color: #fff;
  }
`;

const ContentSection = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  padding-bottom: 5rem;
  padding-left: ${({ isMobile }) => (isMobile ? "1.5rem" : "2rem")};
  padding-right: ${({ isMobile }) => (isMobile ? "1.5rem" : "2rem")};
`;

const GridItem = styled(Grid)`
  > div {
    height: 100%;
  }
`;

const GridBox = styled.div`
  width: 100%;
  height: 100%;
  padding: 2.5rem;
  border-radius: 1rem;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

  word-break: keep-all;
  text-align: center;

  > h3 {
    font-family: "GmarketSansMedium";
    font-size: 7rem;
    font-weight: bold;
    color: #00796b;
  }
  > div {
    font-family: "GmarketSansMedium";
    font-size: 1.7rem;
    font-weight: bold;
    color: #004d40;
    padding-top: 1rem;
    padding-bottom: 1.5rem;
  }
  > p {
    font-size: 1.2rem;
    color: #475569;
  }
`;

const ContentTitle = styled.div`
  word-break: keep-all;
  font-family: "GmarketSansMedium";
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  color: #004d40;
  padding-top: 5rem;
  padding-bottom: 5rem;
`;

const BgContentSection = styled.div`
  width: 100%;
  height: auto;
  margin-top: 5rem;
  background-color: #00796b;
  padding: 3rem;
`;

const TextBox = styled.div`
  word-break: keep-all;
  margin-bottom: ${({ isMobile }) => (isMobile ? "2rem" : "3rem")};
  padding-left: ${({ isMobile }) => (isMobile ? "0" : "1rem")};
  padding-right: ${({ isMobile }) => (isMobile ? "0" : "1rem")};

  > h5 {
    font-family: "GmarketSansMedium";
    font-size: ${({ isMobile }) => (isMobile ? "1.5rem" : "2rem")};
    font-weight: bold;
    color: #fff;
    padding-bottom: 1rem;
  }

  > p {
    font-size: ${({ isMobile }) => (isMobile ? "1rem" : "1.2rem")};
    color: #fff;
  }
`;

const WhiteButtonLink = styled(Link)`
  word-break: keep-all;
  text-align: center;
  width: auto;
  max-width: 300px;
  font-size: ${({ isMobile }) => (isMobile ? "0.9rem" : "1.2rem")};
  font-weight: 800;
  background-color: #fff;
  color: #004d40;
  padding: 1rem 2rem;
  border-radius: 1rem;
  text-decoration: none;
  border: 1px solid #004d40;
  transition: all 0.2s ease;
  margin-bottom: ${({ isMobile }) => (isMobile ? "3rem" : "0")};

  :hover {
    background-color: #004d40;
    color: #fff;
  }
`;
